<template>
  <div>
    <el-dialog
      class="edit-dialog delete-dialog"
      title="提示"
      ref="ruleForm"
       width="30%"
      :visible.sync="dialogFormVisible"
      @close="editCallback"
    >

      <span style="font-size:16px"><i
          class="el-icon-warning"
          style="color:red;"
        ></i> 你确定要删除此条数据吗?</span>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button type="primary" @click="handleDelete()">是</el-button>
        <el-button type="danger" @click="editCallback">否</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
export default {
  name: "DeleteDialog",
   props: {
    deleteVisible: {
      type: Boolean,
      required: true,
    },
   data: {
      type: Object,
      default: {},
    },
    
  },
  data() {
    return {
      dialogFormVisible: this.deleteVisible,
    };
  },
  methods:{
    editCallback(){
      this.$emit("update:deleteVisible", false);
    },
    handleDelete(){
      this.$emit("handleDelete", this.data);
    }
  },
};
</script>
<style>
.delete-dialog .el-dialog__body {
    /* border-bottom: 1px #eceaea solid !important; */
    padding: 20px 20px !important;
  }
.delete-dialog .el-button{
    padding: 10px 30px;
}

.delete-dialog .el-dialog__header {
    padding: 0px 20px 10px;
    border-bottom:none;
}
</style>

<style lang='scss' scoped>


</style>


// WEBPACK FOOTER //
// src/components/common/page/DeleteDialog.vue